import { render } from "./App.vue?vue&type=template&id=571a1771&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=571a1771&scoped=true&lang=scss"
import "./App.vue?vue&type=style&index=1&id=571a1771&lang=scss"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-571a1771"]])

export default __exports__